// Translations
export const T = {
  en_GB: {
    title: "Override fee",
    description:
      "The new value applies to this advice session wherever the fee is used. The client sees the catalogue value struck through.",
    value: "Value",
    catalogueValue: (value: string) => `Catalogue value: ${value}`,
    note: "Note",
    noteRequired: "Note (required)",
    notePlaceholder: "Why is this fee overridden?",
    noteHint: "Only advisors see the note.",
    cancel: "Cancel",
    save: "Save",
    reset: "Reset to catalogue value",
    invalidValue: "Enter a number of at least 0.",
    invalidPercent: "Enter a percentage from 0 to 100.",
    noteMissing: "A note is required for this fee.",
    resetOnlyHint:
      "New overrides of this fee are switched off, but this one still applies until you reset it.",
  },
  nb_NO: {
    title: "Overstyr kostnad",
    description:
      "Den nye verdien gjelder i denne rådgivningen overalt der kostnaden brukes. Kunden ser katalogverdien overstreket.",
    value: "Verdi",
    catalogueValue: (value: string) => `Katalogverdi: ${value}`,
    note: "Begrunnelse",
    noteRequired: "Begrunnelse (påkrevd)",
    notePlaceholder: "Hvorfor overstyres denne kostnaden?",
    noteHint: "Bare rådgivere ser begrunnelsen.",
    cancel: "Avbryt",
    save: "Lagre",
    reset: "Tilbakestill til katalogverdi",
    invalidValue: "Skriv inn et tall på minst 0.",
    invalidPercent: "Skriv inn en prosent fra 0 til 100.",
    noteMissing: "Denne kostnaden krever en begrunnelse.",
    resetOnlyHint:
      "Nye overstyringer av denne kostnaden er slått av, men denne gjelder til du tilbakestiller den.",
  },
} as const;
